import { UseQueryDefaultOptions } from '@front/hook/Api/common';
import { DEFAULT_TIMEOUT } from '@front/hook/Api/utils/consts';
import { signalToTimeout } from '@front/hook/Api/utils/signalToTimeout';
import { ImportTableDefinitionRepository } from '@front/repository/Api/ImportTableDefinition';
import { useQuery } from '@tanstack/react-query';
import { AuthDomain } from 'auth-lib-front';
import { DomainV2 } from 'troppus-common/domain';

import Project = AuthDomain.Object.Project;
import ImportTableDefinition = DomainV2.Import.ImportTableDefinition;

import { importTableDefinitionQueryKeys } from './queryKeys';

const repository = new ImportTableDefinitionRepository();

type Params = {
  projectId: Project.Id;
  id: ImportTableDefinition.Id | undefined;
};

type Options = {
  enabled?: boolean;
};

export const _listRevisions = ({ projectId, id }: Params, options?: Options) => {
  return useQuery({
    queryKey:
      id !== undefined
        ? importTableDefinitionQueryKeys.revisions(projectId, id)
        : (['troppus', 'importTableDefinition', 'revisions', projectId, 'pending'] as const),
    queryFn: async ({ signal }) => {
      if (id === undefined) return [];
      return repository.listRevisions({ projectId, id }, { signal: signalToTimeout(DEFAULT_TIMEOUT.QUERY, signal) });
    },
    enabled: (options?.enabled ?? true) && id !== undefined,
    ...UseQueryDefaultOptions,
  });
};
